import Card from "../../../../../../../common/element/Card";
import BtnLight from "../../../../../../../common/element/Buttons/btnLight";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { GetSpecificWorkerProfileById } from "../../../../../../../actions/provider-portal/worker/GetSpecificWorkerProfileById";
import { useSelector } from "react-redux";
import { ProviderWorkerProfileData } from "../../../../../../../redux/classes/provider-portal/ProviderWorkerSpecificData";
const WorkerInformation = ({ openAddDialog }) => {
  const { specificWorker } = useSelector((state) => state);
  const [workerRedirectSpecificData, SetworkerRedirectSpecificData] = useState()
  const dispatch = useDispatch();
  
  useEffect(()=>{
    dispatch(GetSpecificWorkerProfileById({individual_id:specificWorker?.worker_individual?.individual_id})).then((response)=>{
      if(response.success){
        dispatch(ProviderWorkerProfileData(response.data))
        SetworkerRedirectSpecificData(response.data)
      }
    })
  },[])
  return (
    <Card className="p-6 border border-gray-200 rounded-xl dark-shadow">
      <div className="card-header flex justify-between border-b border-gray-200 pb-5 mb-5">
        <span className="text-gray-900 text-base font-semibold flex items-center">
          <span className="mr-4">
            <img src="/assets/icons-svg/building-icon.svg" />
          </span>
          Worker Information
        </span>
        <span className="text-gray-500 text-sm font-normal flex items-center gap-2">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33334 8 1.33334C4.3181 1.33334 1.33334 4.3181 1.33334 8C1.33334 11.6819 4.3181 14.6667 8 14.6667Z" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 10.6667V8" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 5.33334H8.00667" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          To edit details please contact support
        </span>
      </div>
      <div className="flex mb-3">
        <div className="flex-1">
          <span className="text-gray-400 font-semibold block text-sm mb-1">
            First name
          </span>
          <span className="text-gray-900 font-medium block text-sm">
            {workerRedirectSpecificData?.first_name ? workerRedirectSpecificData?.first_name : "-"}
          </span>
        </div>
        <div className="flex-1">
          <span className="text-gray-400 font-semibold block text-sm mb-1">
            Last name
          </span>
          <span className="text-gray-900 font-medium block text-sm">
            {workerRedirectSpecificData?.last_name ? workerRedirectSpecificData?.last_name : ""}
          </span>
        </div>
      </div>
      <div className="flex mb-3">
        <div className="flex-1">
          <span className="text-gray-400 font-semibold block text-sm mb-1">
            Email
          </span>
          <span className="text-gray-900 font-medium block text-sm">
            {workerRedirectSpecificData?.email ? workerRedirectSpecificData?.email : "-"}
          </span>
        </div>
        <div className="flex-1">
          <span className="text-gray-400 font-semibold block text-sm mb-1">
            Phone
          </span>
          <span className="text-gray-900 font-medium block text-sm">
            {workerRedirectSpecificData?.phone ? workerRedirectSpecificData?.phone : "-"}
          </span>
        </div>
      </div>
      <div className="flex mb-3">
        <div className="flex-1">
          <span className="text-gray-400 font-semibold block text-sm mb-1">
            Country
          </span>
          <span className="text-gray-900 font-medium flex gap-1 text-sm">
            {workerRedirectSpecificData?.name ? workerRedirectSpecificData?.name : "-"}

          </span>
        </div>
        <div className="flex-1">
          <span className="text-gray-400 font-semibold block text-sm mb-1">
            State
          </span>
          <span className="text-gray-900 font-medium flex gap-1 text-sm">
          {workerRedirectSpecificData?.state_name ? workerRedirectSpecificData?.state_name : "-"}
          </span>
        </div>
      </div>
      <div className="flex mb-3">
        <div className="flex-1">
          <span className="text-gray-400 font-semibold block text-sm mb-1">
            Job title
          </span>
          <span className="text-gray-900 font-medium flex gap-1 text-sm">
          {workerRedirectSpecificData?.name ? workerRedirectSpecificData?.name : "-"}
          </span>
        </div>
      </div>
    </Card>
  );
};
export default WorkerInformation;
